import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toPersianNum, toSeperatedNum } from "../../assets/utils";
import { setShownSuggestionPrice } from "../../redux/newRequest/newRequest.actions";
import {
  selectNewRequestSuggestionPrice,
  selectNewRequestSuggestionPriceIsLoading,
} from "../../redux/newRequest/newRequest.selectors";
import { roundToThousand } from "../../utils/utils";
import LoadingText from "../loadingText/loadingText.component";
import { SubmitReqPreSugestedPriceStyled } from "./submitReqPreSugestedPrice.styles";

const SubmitReqPreSugestedPrice = ({ isInstant }) => {
  const dispatch = useDispatch();
  const selectSugestion = useSelector(selectNewRequestSuggestionPrice);
  const selectSugestionIsLoading = useSelector(
    selectNewRequestSuggestionPriceIsLoading
  );

  const [price, setPrice] = useState();
  const [minesIsActive, setMinesIsActive] = useState(false);

  useEffect(() => {
    dispatch(setShownSuggestionPrice(price));
  }, [price]);

  useEffect(() => {
    setPrice(selectSugestion.suggested_price);
  }, [selectSugestion]);

  const initialPrice = selectSugestion.suggested_price;

  const priceStep = Number(((Number(initialPrice) * 5) / 100).toFixed());

  const onLowerPrice = () => {
    const newPrice = price - roundToThousand(priceStep);
    const formatedPrice = roundToThousand(newPrice);
    if (formatedPrice <= initialPrice) {
      setPrice(initialPrice);
      setMinesIsActive(false);
      return;
    }

    setPrice(formatedPrice);
  };
  const onUpperPrice = () => {
    const newPrice = price + roundToThousand(priceStep);
    const formatedPrice = roundToThousand(newPrice);
    setMinesIsActive(true);

    setPrice(formatedPrice);
  };
  // console.log(selectSugestion);
  return (
    <SubmitReqPreSugestedPriceStyled>
      {selectSugestionIsLoading ? (
        <LoadingText className="d-inline-flex" />
      ) : (
        <div className="d-flex align-items-center justify-content-around">
          <button onClick={onUpperPrice}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 18 18"
            >
              <g fill="white" id="Group_1147" transform="translate(-42 -540)">
                <g
                  id="Rectangle_906"
                  fill="none"
                  transform="translate(60 558) rotate(180)"
                  stroke="#9496A0"
                >
                  <rect width="18" height="18" stroke="none" rx="7"></rect>
                  <rect width="17" height="17" x=".5" y=".5" rx="6.5"></rect>
                </g>
                <path
                  id="Line_75"
                  d="M0 0L8 0"
                  transform="translate(47 549.5)"
                  stroke="#9496A0"
                ></path>
                <path
                  id="Line_174"
                  d="M0 0L8 0"
                  transform="translate(51 545.5) rotate(90)"
                  stroke="#9496A0"
                ></path>
              </g>
            </svg>
          </button>

          <div>
            {!isInstant ? (
              <span>
                {initialPrice ? (
                  <span>حداقل مبلغ کرایه: </span>
                ) : (
                  <span>کرایه توافقی</span>
                )}
                <span>
                  {toSeperatedNum(toPersianNum(selectSugestion.from))}
                </span>
              </span>
            ) : (
              <span>
                <span>کرایه حمل: </span>
                <span>{toSeperatedNum(toPersianNum(price))}</span>
              </span>
            )}
            {initialPrice ? <span> تومان</span> : ""}
          </div>
          <button onClick={onLowerPrice} disabled={!minesIsActive}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 18 18"
            >
              <g stroke="white" opacity="0.5">
                <g transform="translate(-42 -540) translate(60 558) rotate(180)">
                  <rect width="18" height="18" stroke="none" rx="7" />
                  <rect width="17" height="17" x=".5" y=".5" rx="6.5" />
                </g>
                <path
                  strokeLinecap="round"
                  d="M0 0L8 0"
                  transform="translate(-42 -540) translate(47 549.5)"
                />
              </g>
            </svg>
          </button>
        </div>
      )}
    </SubmitReqPreSugestedPriceStyled>
  );
};

export default SubmitReqPreSugestedPrice;
